import { motion } from "framer-motion";
import { IMAGES } from "@/data/site";

const ITEMS = [
  { img: IMAGES.tiles, title: "Terrasse sur plots", tag: "Dalles / Fréjus", span: "lg:col-span-2 lg:row-span-2" },
  { img: IMAGES.membrane, title: "Membrane bitumineuse", tag: "Toiture terrasse" },
  { img: IMAGES.terrace, title: "Balcon étanché", tag: "Cannes" },
  { img: IMAGES.concrete, title: "Murs enterrés", tag: "Cuvelage" },
  { img: IMAGES.terraceWork, title: "Couvertine aluminium", tag: "Acrotère" },
];

export const Realisations = () => {
  return (
    <section id="realisations" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-32">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
        <div>
          <span className="text-xs tracking-[0.25em] uppercase text-mh-orange font-bold">Réalisations</span>
          <h2 className="mt-5 font-display font-bold text-4xl sm:text-5xl tracking-tight text-white leading-[0.95]">
            Des chantiers qui parlent d'eux-mêmes
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 auto-rows-[220px] lg:auto-rows-[260px] gap-4">
        {ITEMS.map((it, i) => (
          <motion.figure
            key={i}
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: (i % 4) * 0.08 }}
            className={`group relative overflow-hidden border border-mh-line clip-corner ${it.span || ""} ${i === 0 ? "col-span-2" : ""}`}
            data-testid={`realisation-${i}`}
          >
            <img src={it.img} alt={it.title} className="w-full h-full object-cover img-arch transition-transform duration-[900ms] group-hover:scale-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-mh-bg/90 via-transparent to-transparent" />
            <figcaption className="absolute bottom-5 left-5 right-5">
              <div className="text-[10px] tracking-[0.25em] uppercase text-mh-orange font-bold">{it.tag}</div>
              <div className="mt-1 font-display font-bold text-white text-lg tracking-tight">{it.title}</div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
};
